import firebase from 'firebase';

export default class HauteFire {
    constructor() {
        let config = {
            apiKey: "AIzaSyDhtIn35zo7sfJGZZawxFzPf3tFt7oT76w",
            authDomain: "haute-islands.firebaseapp.com",
            databaseURL: "https://haute-islands.firebaseio.com",
            projectId: "haute-islands",
            storageBucket: "haute-islands.appspot.com",
            messagingSenderId: "709476992106"
        };

        if (firebase.apps.length == 0)
            firebase.initializeApp(config);
    }

    // ----- GENERAL STARTS -----

    addUpdate(id, obj, tableName) {
        if (id != "" || id == 0) {
            firebase.database().ref(tableName + "/" + id).set(obj);
        }
        else {
            firebase.database().ref(tableName + "/").set(obj);
        }
    }

    // ----- GENERAL ENDS -----

    // ----- STORAGE STARTS -----

    uploadFile(file, location) {

        let filePromise = new Promise((resolve, reject) => {
            let storageRef = firebase.storage().ref();

            // Create the file metadata
            let metadata = {
                contentType: 'image/jpeg'
            };

            // Upload file and metadata to the object 'images/mountains.jpg'
            let uploadTask = storageRef.child(location + '/' + file.name).put(file, metadata);

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                function (snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                }, function (error) {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            break;

                        case 'storage/canceled':
                            // User canceled the upload
                            break;

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            break;

                        default:
                            console.error(error);
                            break;
                    }
                }, function () {
                    // Upload completed successfully, now we can get the download URL
                    let downloadURL = uploadTask.snapshot.downloadURL;
                    if (downloadURL != "")
                        resolve(downloadURL);
                    else
                        reject("Error while uploading");
                });
        });
        return filePromise;
    }

    deleteFile(filePath) {
        var storage = firebase.storage();
        var storageRef = storage.ref();
        let urlRef = storageRef.child(filePath);

        //Delete the file
        let promise = new Promise((resolve, reject) => {
            urlRef.delete().then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })

        return promise;
    }

    // ----- STORAGE ENDS -----

    // ----- EXCLUSIVE FEATURES STARTS -----

    addExclusiveFeatures(features) {
        firebase.database().ref('ExclusiveFeatures/').set(features);
    }

    getExclusiveFeatures() {
        let promise = new Promise((resolve, reject) => {
            let featureRef = firebase.database().ref('ExclusiveFeatures/');
            featureRef.on('value', ((response) => {
                resolve(response.val())
            }))
        })

        return promise;
    }

    // ----- EXCLUSIVE FEATURES ENDS -----

    // ----- LOGO STARTS -----
    addLogoUrl(obj) {
        let id = new Date().getTime();

        return firebase.database().ref("/HauteDetails/logoUrls").once('value').then((response) => {
            let logoUrls = response.val();
            debugger;
            if (logoUrls != null) {
                let order, _index;
                let logoKeys = Object.keys(logoUrls);
                for (let i = 0; i < logoKeys.length; i++) {
                    if (logoUrls[logoKeys[i]].islandId == obj.islandId) {
                        _index = i;
                        break;
                    }
                }
                if (_index != undefined) {
                    id = logoUrls[_index].id;
                    order = logoUrls[_index].order;
                }
                else {
                    _index = logoUrls.length;
                    order = _index; //Object.keys(logoUrls).length + 1;
                }

                debugger;
                this.addUpdate(_index, {
                    id: id,
                    islandId: obj.islandId,
                    islandName: obj.islandName,
                    name: obj.name,
                    url: obj.url,
                    order: order
                }, "/HauteDetails/logoUrls");
            }
            else {
                this.addUpdate(0, {
                    id: id,
                    islandId: obj.islandId,
                    islandName: obj.islandName,
                    name: obj.name,
                    url: obj.url,
                    order: 1
                }, "/HauteDetails/logoUrls");
            }
        })


    }

    // ----- LOGO ENDS -----

    // ----- RANDOM COLOR STARTS -----
    getDateFormat(_day) {
        _day = new Date(_day);
        let _date = _day.getDate().toString();
        _date = _date.length == 1 ? `0${_date}` : _date;
        const month = (_day.getMonth() + 1);
        const year = _day.getFullYear();

        return `${year}-${month}-${_date}`;
    }

    rgbRandomColors(colorLength) {
        let colors = [];
        for (let i = 0; i < colorLength; i++) {
            const r = Math.floor(Math.random() * 255);
            const g = Math.floor(Math.random() * 255);
            const b = Math.floor(Math.random() * 255);

            colors.push(`rgb(${r},${g},${b}`);
        }

        return colors;
    }

    // ----- RANDOM COLOR ENDS -----
}


// WEBPACK FOOTER //
// ./src/views/Utils/HauteFire.js